<template>
  <div>
    <NavHeader :activeIndex="'ContactUs'" />


    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing lead-info-box e_font_family">
      <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
        <div class="profile-info d-sm-flex align-items-center">
          <img src="@/assets/images/join2.jpg" class="rounded" alt="user" />
          <div class="title mt-12 mt-sm-0">
            <!-- <h5 class="text-black fw-medium mb-8"> {{ userInfo.name }}</h5> -->
            <span class="d-block fs-md-15 fs-lg-16 text-dark-emphasis mb-8">
              扫描左侧微信二维码<span class="text-danger">(微信添加不成功，请添加QQ)</span>
            </span>
            <span class="d-block fw-bold text-primary">有问题随时联系，期待您的加入</span>
          </div>
        </div>
        <div class="border-top mt-15 mb-15 mt-sm-20 mb-sm-20 mt-md-25 mb-md-25 mt-lg-30 mb-lg-30"></div>
        <div class="d-flex align-items-center justify-content-between">
        </div>
        <ul class="info mt-25 ps-0 mb-0 list-unstyled">
          <li class="position-relative">
            <div class="icon text-success rounded-circle text-center ">
                <feather-icon icon="UserPlusIcon" size="20" class="mt-12 ms-1"/>
            </div>
            <span class="d-block text-black mb-5 fw-semibold">
              微信：
            </span>
            <span class="d-inline-block fs-md-15 fs-lg-16 text-muted">
              footballprediction88
            </span>
          </li>
          <li class="position-relative">
            <div class="icon text-success rounded-circle text-center">
              <feather-icon icon="UserPlusIcon" size="20" class="mt-12 ms-1"/>
            </div>
            <span class="d-block text-black mb-5 fw-semibold">
              QQ：
            </span>
            <span class="d-inline-block fs-md-15 fs-lg-16 text-muted">
              296682978
            </span>
          </li>
          <li class="position-relative">
            <div class="icon text-success rounded-circle text-center">
              <feather-icon icon="WatchIcon" size="20" class="mt-12 ms-1"/>
            </div>
            <span class="d-block text-black mb-5 fw-semibold">工作时间</span>
            <span class="d-inline-block fs-md-15 fs-lg-16 text-muted">
              早上7:00-晚上23:00
            </span>
          </li>

        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import NavHeader from './NavHeader.vue'

export default {
  components: {
    NavHeader
  },
  data() {
    return {
      ifShowLogo: false
    }
  },
  computed: {


  },
  created() {
    if (window.innerWidth <= 768) {
      this.ifShowLogo = true;
    }
  },

  methods: {

  },
}
</script>

<style lang="scss" scoped>
.e_font_family {
  font-family: PingFangSC-Regular, Microsoft YaHei, Heiti, Arial, Helvetica, "sans-serif" !important;
}
</style>
